import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EmployeeCountColumn extends Column {
    title = 'table.workers-compensations.employeeCount';
    property = 'employeesAssignedCount';
    type: CellDisplay = CellDisplay.string;
}
